
export default {
	methods: {
		_dataURLtoFile(dataurl, filename) {
			var arr = dataurl.split(','),
				mime = arr[0].match(/:(.*?);/)[1],
				bstr = atob(arr[1]),
				n = bstr.length,
				u8arr = new Uint8Array(n)
			while (n--) {
				u8arr[n] = bstr.charCodeAt(n)
			}
			return new File([u8arr], filename, {type: mime})
		},

		_enviarImagem(callback, img, token) {
			let tk = ''

			if (_.isNil(token)) {
				tk = this.getToken()
			} else {
				tk = token
			}

			var contentType = img.split(';')[0].split(':')[1].replace('image/', '.')
			var file = this._dataURLtoFile(img, 'image' + contentType)

			// Create a FormData and append the file with "image" as parameter name
			var formDataToUpload = new FormData()
			formDataToUpload.append('arquivo', file)

			this.enviando = true
			this.erroMSG = ''

			var self = this
			jQuery.ajax({
				cache: false,
				contentType: false,
				processData: false,
				type: 'POST',
				headers: {Authorization: tk},
				data: formDataToUpload,
				url: this.urlEnvio,
				dataType: 'json',
				success: function (retorno) {
					//console.log(retorno)
					callback(retorno)
				},
				error: function (e) {
					callback(false)
					//console.log(e);
					bus.$emit('modal-erro-show', e)
				}
			})
		}
	}
}